export const blockIconsAndroidBatteryChargingFullNew = (
	<span className='material-symbols-outlined'>battery_charging_full</span>
);
